// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'lateral', 'lateral Fallback'","fontWeight":700,"fontStyle":"normal"},"className":"__className_e6eeaa","variable":"__variable_e6eeaa"};